/*export const initialState = {
    basket: [],
    user: null
};

export const getBasketTotal = (basket) => basket?.reduce((amount, item) => amount + item.price * (item.quantity || 1), 0);


const reducer = (state, action) => {
    console.log(action);
    switch(action.type) {
        case 'ADD_TO_BASKET': {
            let payload = null;

            const hasVariants = Array.isArray(action.item.variants) && action.item.variants.length > 0;

            if(!hasVariants){
              payload = {
                ...action.item,
                quantity: Number(action.item?.quantity) || 1,
                size: action.item?.size ?? null,
                price: Number(action.item.price)
              };
            }else{
              let chosenVariant = null;

              if ((!action.item.size || action.item.size === "") && Array.isArray(action.item.variants)) {
                chosenVariant = action.item.variants.reduce((min, v) =>
                  Number(v.price) < Number(min.price) ? v : min
                );
              }

              payload = {
                ...action.item,
                quantity: Number(action.item?.quantity) || 1,
                size: chosenVariant ? chosenVariant.size : (action.item?.size ?? null),
                price: chosenVariant ? Number(chosenVariant.price) : Number(action.item.price),
                originalID: chosenVariant ? chosenVariant.originalID : action.item.originalID
              };
            }
          
            const isSameItem = (a, b) => {
              const aId = a.originalID ?? a.id;
              const bId = b.originalID ?? b.id;
              const aSize = a.size ?? null;
              const bSize = b.size ?? null;
          
              return aId === bId && aSize === bSize;
            };

            console.log('[ADD_TO_BASKET] payload:', payload);
            console.log('[ADD_TO_BASKET] state.basket before:', state.basket);

          
          
            const existingIndex = state.basket.findIndex(cartItem => isSameItem(cartItem, payload));
            console.log('[REDUCER] ADD_TO_BASKET payload:', payload, 'existingIndex:', existingIndex);
          
            if (existingIndex !== -1) {
              // Crea un nuovo array immutabile
              const newBasket = state.basket.map((item, idx) => {
                if (idx !== existingIndex) return item;
          
                const oldQuantity = Number(item.quantity) || 0;
                const addQuantity = Number(payload.quantity) || 1;
                const newQuantity = oldQuantity + addQuantity;
          
                console.log(`[REDUCER] increment quantity: ${oldQuantity} + ${addQuantity} = ${newQuantity}`);
          
                return { ...item, quantity: newQuantity };
              });
          
              console.log('[REDUCER] new basket after increment:', newBasket);
              return { ...state, basket: newBasket };
            }
          
            const newBasket = [...state.basket, payload];
            console.log('[REDUCER] new basket after push:', newBasket);
            return { ...state, basket: newBasket };
          } 
        
        case 'EMPTY_BASKET':
            return {
                ...state,
                basket: []
            };
        
        case 'REMOVE_FROM_BASKET': {
            const cartId = String(action.id ?? '').trim();
            const sizeToRemove = action.size ?? null;
          
            const index = state.basket.findIndex(item => {
              const itemId = String(item.originalID ?? item.id);
              const itemSize = item.size ?? null;
              return itemId === cartId && itemSize === sizeToRemove;
            });
          
            if (index < 0) return state;
          
            const newBasket = [...state.basket];
            const currentQty = Number(newBasket[index].quantity) || 1;
          
            if (currentQty > 1) {
              newBasket[index] = {
                ...newBasket[index],
                quantity: currentQty - 1
              };
            } else {
              newBasket.splice(index, 1);
            }
          
            return { ...state, basket: newBasket };
          }
            
                          

        case 'SET_USER':
            return {
                ...state,
                user: action.user
            }

        case 'SET_BASKET_FROM_DB':
            return {
                ...state,
                basket: action.basket
            }

        default:
            return state;
    }
};

export default reducer;*/

export const initialState = {
  basket: [],
  user: null
};

export const getBasketTotal = (basket) => basket?.reduce((amount, item) => amount + item.price * (item.quantity || 1), 0);

const reducer = (state, action) => {
  console.log(action);
  switch(action.type) {
      case 'ADD_TO_BASKET': {
          let payload = null;

          const hasVariants = Array.isArray(action.item.variants) && action.item.variants.length > 0;

          if(!hasVariants){
            payload = {
              ...action.item,
              quantity: Number(action.item?.quantity) || 1,
              size: action.item?.size ?? null,
              price: Number(action.item.price),
              peso: Number(action.item.peso || action.item.weight || 0)
            };
          }else{
            let chosenVariant = null;

            if ((!action.item.size || action.item.size === "") && Array.isArray(action.item.variants)) {
              chosenVariant = action.item.variants.reduce((min, v) =>
                Number(v.price) < Number(min.price) ? v : min
              );
            }

            payload = {
              ...action.item,
              quantity: Number(action.item?.quantity) || 1,
              size: chosenVariant ? chosenVariant.size : (action.item?.size ?? null),
              price: chosenVariant ? Number(chosenVariant.price) : Number(action.item.price),
              originalID: chosenVariant ? chosenVariant.originalID : action.item.originalID,
              peso: Number(chosenVariant?.peso || chosenVariant?.weight || action.item.peso || action.item.weight || 0)
            };
          }
        
          const isSameItem = (a, b) => {
            const aId = a.originalID ?? a.id;
            const bId = b.originalID ?? b.id;
            const aSize = a.size ?? null;
            const bSize = b.size ?? null;
        
            return aId === bId && aSize === bSize;
          };

          console.log('[ADD_TO_BASKET] payload:', payload);
          console.log('[ADD_TO_BASKET] state.basket before:', state.basket);

          const existingIndex = state.basket.findIndex(cartItem => isSameItem(cartItem, payload));
          console.log('[REDUCER] ADD_TO_BASKET payload:', payload, 'existingIndex:', existingIndex);
        
          if (existingIndex !== -1) {
            const newBasket = state.basket.map((item, idx) => {
              if (idx !== existingIndex) return item;
        
              const oldQuantity = Number(item.quantity) || 0;
              const addQuantity = Number(payload.quantity) || 1;
              const newQuantity = oldQuantity + addQuantity;
        
              console.log(`[REDUCER] increment quantity: ${oldQuantity} + ${addQuantity} = ${newQuantity}`);
        
              return { ...item, quantity: newQuantity };
            });
        
            console.log('[REDUCER] new basket after increment:', newBasket);
            return { ...state, basket: newBasket };
          }
        
          const newBasket = [...state.basket, payload];
          console.log('[REDUCER] new basket after push:', newBasket);
          return { ...state, basket: newBasket };
        } 
      
      case 'EMPTY_BASKET':
          return {
              ...state,
              basket: []
          };
      
      case 'REMOVE_FROM_BASKET': {
          const cartId = String(action.id ?? '').trim();
          const sizeToRemove = action.size ?? null;
        
          const index = state.basket.findIndex(item => {
            const itemId = String(item.originalID ?? item.id);
            const itemSize = item.size ?? null;
            return itemId === cartId && itemSize === sizeToRemove;
          });
        
          if (index < 0) return state;
        
          const newBasket = [...state.basket];
          const currentQty = Number(newBasket[index].quantity) || 1;
        
          if (currentQty > 1) {
            newBasket[index] = {
              ...newBasket[index],
              quantity: currentQty - 1
            };
          } else {
            newBasket.splice(index, 1);
          }
        
          return { ...state, basket: newBasket };
        }

      case 'SET_USER':
          return {
              ...state,
              user: action.user
          }

      case 'SET_BASKET_FROM_DB':
          return {
              ...state,
              basket: action.basket
          }

      default:
          return state;
  }
};

export default reducer;